import React from 'react';

const Checkmark = ({ ...r }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 17" {...r}>
			<path
				fill="#FDB727"
				fillRule="evenodd"
				d="M4.706 4.831H0v.874h1.092v6.253H0v.873h6.878V9.437H6v.504c0 .826-.268 1.313-.678 1.604-.423.3-1.025.413-1.732.413h-.087V5.705h1.203V4.83zm6.151 0H7.438v.874h.357c.33 0 .663.27.663.681v4.965c0 .3-.08.434-.163.502-.092.075-.228.105-.408.105h-.486v.873h3.04v-.873h-.381c-.169 0-.304-.007-.413-.024a.573.573 0 01-.23-.078c-.083-.055-.146-.16-.146-.449V6.963l4.517 5.868h1.156V6.115a.35.35 0 01.125-.262c.09-.08.246-.148.496-.148H16V4.83h-3.046v.874h.497c.257 0 .427.048.529.12.09.066.144.164.144.324V9.06l-3.267-4.229z"
				clipRule="evenodd"
			></path>
		</svg>
	);
};

export default Checkmark;
